'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import API from './API';
var URL = 'websitegrader/v2/grade/';
var timeout = 60000;

var _default = /*#__PURE__*/function (_API) {
  _inherits(_default, _API);

  function _default() {
    _classCallCheck(this, _default);

    return _possibleConstructorReturn(this, _getPrototypeOf(_default).apply(this, arguments));
  }

  _createClass(_default, [{
    key: "get",
    value: function get(websiteUrl) {
      return this.makeGetRequest(URL + websiteUrl, {
        timeout: timeout
      });
    }
  }, {
    key: "post",
    value: function post(websiteUrl) {
      return this.makePostRequest(URL + websiteUrl, {
        timeout: timeout
      });
    }
  }]);

  return _default;
}(API);

export { _default as default };